export type allDataType = {
  floors : floorType[]
}
export type floorType = {
  areas: areaType[]
}
export type areaType = {
  title: string,
  lead: string,
  slides: {
    text: string,
    modals: {
      x: number,
      y: number,
      title: string,
      lead1: string,
      lead2: string,
      url: string,
    }[]
  }[]
}

const allData: allDataType = {
  floors: [
    {
      areas: [
        {
          // floor3/area01
          title: "normann copenhagen <span>[ノーマンコペンハーゲン]</span>",
          lead: "大胆で創造性溢れるデザインアイテムを創造、「特別なスタンダード」を生みだすデンマークの家具ブランド。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/brandcollection/",
                }
              ]
            }
          ]
        },{
          // floor3/area02
          title: "MATTIAZZI <span>[マティアッティ]</span>",
          lead: "有名デザイナーとのコラボレーションでエッジの効いた独特なデザインを展開するイタリアの家具ブランド。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/brandcollection/mattiazzi/",
                }
              ]
            }
          ],
        },{
          // floor3/area03
          title: "PEDRALI <span>[ペドラリ]</span>",
          lead: "様々な素材を使いながら、繊細で革新的な研究に基づいて製品を開発するイタリア・ベルガモの家具ブランド。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/brandcollection/pedrali/",
                }
              ]
            }
          ],
        },{
          // floor3/area04
          title: "MAGIS <span>[マジス]</span>",
          lead: "ニューヨーク近代美術館やパリ国立近代美術館など、世界のミュージアムで<br />パーマネントコレクションに選ばれるブランド。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/brandcollection/magis/",
                }
              ]
            }
          ],
        },{
          // floor3/area05
          title: "STELLAR WORKS <span>[ステラ―ワークス]</span>",
          lead: "「東洋と西洋」「伝統とモダン」など、異なるアイデアをつなぎ合わせてデザインする上海のラグジュアリーブランド。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/brandcollection/#N/A",
                }
              ]
            }
          ],
        },{
          // floor3/area06
          title: "Wilkhahn <span>[ウィルクハーン]</span>",
          lead: "ドイツに生まれ、ドイツに育まれたモダニズムの原理を守りながら、クオリティにこだわり、イノベーションを追求し続けるブランド。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.wilkhahn.co.jp/products/",
                }
              ]
            }
          ],
        },{
          // floor3/area07
          title: "SENTIR <span>[センティア]</span>",
          lead: "2000通りを越えるオーダーメイドのような選択肢で、気分やスタイルに応える革新的なワークテーブル。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://kokuyo.jp/sentir/",
                }
              ]
            }
          ],
        },{
          // floor3/area08
          title: "SAIBI <span>[サイビ]</span>",
          lead: "人が心地よく働くための理想をデザインに昇華。美と機能の両立が、真の快適さを生みだす上質なテーブル。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://kokuyo.jp/saibi/",
                }
              ]
            }
          ],
        },{
          // floor3/area09
          title: "SEQUENCE <span>[シークエンス]</span>",
          lead: "立ち座りで気分を変えて仕事がはかどる。モードによって最適な高さへ自由自在に変えられる昇降するデスク。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://kokuyo.jp/sequence/",
                }
              ]
            }
          ],
        },{
          // floor3/area10
          title: "個室（間仕切り）",
          lead: "透明度の高いガラスや合わせガラス、ブラインド内蔵のガラスなど、多彩なバリエーションで先進的な空間を生む間仕切り。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/article_06.html",
                }
              ]
            }
          ],
        }
      ]
    },{
      areas: [
        {
          // floor4/area01
          title: "any <span>[エニー]</span>",
          lead: "「あたりまえ」の使い勝手がここちよい、WORK / LIFEのシーンを彩るシンプルチェアー。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 533,
                  y: 381,
                  title: "any <span>[エニー]</span>",
                  lead1: "「あたりまえ」の使い勝手がここちよい、WORK / LIFEのシーンを彩るシンプルチェアー。",
                  lead2: "・キャスターにいたるまで色を揃えた、ノイズのないシンプルなデザイン。<br />・長時間の着座に耐えられる厚手モールドウレタンクッション採用。<br />・空間の多様な使い方をサポートする水平スタッキング収納。",
                  url: "https://kokuyo.jp/any/",
                }
              ]
            }
          ],
        },{
          // floor4/area02
          title: "Plocka・Mycket <span>[プロッカ・ミケット]</span>",
          lead: "カフェ空間やラウンジ空間にマッチするPlocka、シンプルなフォルム、526通りのバリエーションMycket",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 666,
                  y: 340,
                  title: "Plocka <span>[プロッカ]</span>",
                  lead1: "カフェ空間やラウンジ空間にマッチし、<br />色合いが多彩に選べる背座別体チェアー。",
                  lead2: "・カフェ空間に最適な238通りのバリエーションが選べます。<br />・立ち座りの際に気になる床のビビり音を軽減。（4本脚）<br />・30mm厚のクッションで心地よく身体をサポート。（クッション付き仕様）",
                  url: "https://kokuyo.jp/plocka/",
                },{
                  // ?slide=0&modal=1
                  x: 213,
                  y: 236,
                  title: "Mycket <span>[ミケット]</span>",
                  lead1: "シンプルなフォルムと526通りのバリエーションであらゆる空間イメージによりそうダイニングチェアー。",
                  lead2: "・多様な空間イメージに対応する526通りのバリエーションが選べます。<br />・立ち座りの際に気になる床のビビり音を軽減。（4本脚）<br />・30mm厚のクッションで心地よく身体をサポート。（クッション付き仕様）",
                  url: "https://kokuyo.jp/mycket/",
                }
              ]
            }
          ],
        },{
          // floor4/area03
          title: "会議用イス",
          lead: "気軽に使えるパイプイスからスタイリッシュなイス、スタッキングできるイスなど、<br />豊富な機能とデザインから選べる様々な会議用イス",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 188,
                  y: 275,
                  title: "KATE <span>[ケイト]</span>",
                  lead1: "「場をつくる」を、より自由に、よりポジティブにする軽量チェアー。",
                  lead2: "・軽量で運びやすいので、レイアウトや人数の変化に素早く対応。<br />・誰でも軽々とスタッキング。スタッキングは最大4脚まで可能。<br />・見た目も軽快、「抜け感」を感じさせる直線的なデザイン。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/kate/",
                }
              ]
            }
          ],
        },{
          // floor4/area04
          title: "教育",
          lead: "様々な「学びの空間」を提案する教育専用商材。デスクやチェアをはじめ、<br />ロッカーやボードなど多彩なアイテムをご用意。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/manabi/product/",
                }
              ]
            }
          ],
        },{
          // floor4/area05
          title: "医療",
          lead: "病院・クリニック・高齢者福祉施設の働く環境づくりのプロとして、<br />多彩な製品をご提案。医療現場の働き方を変えていく。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/solution/medical/product/",
                }
              ]
            }
          ],
        },{
          // floor4/area06
          title: "官公庁・ロビーチェア",
          lead: '「来庁者満足の向上」「職員サービスの向上」のために、来庁者と職員双方の視点を取り入れた<br />ユニバーサルデザインの製品。',
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 695, y: 421, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/madoguchi/universaldesign/machiai.html",
                },{
                  // ?slide=0&modal=1
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/madoguchi/universaldesign/madoguchi.html",
                }
              ]
            }
          ],
        },{
          // floor4/area07
          title: "オフィスチェアー",
          lead: "デザインも機能もプライスも、多彩に揃ったオフィスチェアー。<br />それぞれの好みや働き方にぴったり合ったチェアーが見つかります。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://kokuyo.jp/chair/",
                }
              ]
            }
          ],
        },{
          // floor4/area08
          title: "DAYS OFFICE <span>[デイズオフィス]</span>",
          lead: "時代のニーズをいち早く取り入れながら、適切な価格で、簡単にシミュレーションでき、<br />スムーズに導入できる「ファスト・オフィス」。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 246,
                  y: 369,
                  title: "DAYS OFFICE hang like <span>[ハングライク]</span>",
                  lead1: "シンプルなフレームに、背を「ひっかけた」ようなデザインが特徴のチェアー。",
                  lead2: "・フレームと背座の組み合わせで532通りのバリエーションが実現。<br />・長く座っていても疲れにくい、緩やかな曲面加工を施した座面。<br />・昇降脚では座面の高さを400mm〜490mmの間で無段階調整が可能。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/daysoffice/lineup/hang_like/#daysoffice",
                },{
                  // ?slide=0&modal=1
                  x: 495,
                  y: 356,
                  title: "DAYS OFFICE offset frame <span>[オフセットフレーム]</span>",
                  lead1: "ミーティングエリアやオープンスペースなど幅広い用途に使えるカジュアルなスタッキングチェアー。",
                  lead2: "・シェルからはみ出したフレームで、スムーズな持ち運びが可能。<br />・座面の高さは390mm〜510mmの間で無段階調整が可能。<br />・佐藤オオキ氏が代表を務める「nendo」によるデザイン。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/daysoffice/lineup/offset_frame/#daysoffice",
                },{
                  // ?slide=0&modal=2
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/daysoffice/feature/",
                },{
                  // ?slide=0&modal=2
                  x: 216,
                  y: 329,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885232001",
                },{
                  // ?slide=0&modal=2
                  x: 475,
                  y: 316,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212883445001",
                }
              ]
            }
          ],
        },{
          // floor4/area09
          title: "会議・ミーティング・コラボレーション",
          lead: "少人数でサクッと行うミーティングから大人数で行う会議まで、様々なシーンや使い勝手に応える<br />会議テーブルのラインナップ。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 501,
                  y: 176,
                  title: "brackets <span>[ブラケッツ]</span>",
                  lead1: "置くだけで空間を「切り出す」<br />モジュール型ソファ&テーブルシステム。",
                  lead2: "・置くだけで多様な空間を生み出し、組み替えも自在です。<br />・オープンオフィスの中に集中しやすいセミクローズ空間をつくります。<br />・柔らかい素材とリラックスした雰囲気でモードチェンジをはかります。",
                  url: "https://kokuyo.jp/brackets/",
                }
              ]
            }
          ],
        },{
          // floor4/area10
          title: "ワークステーション",
          lead: "機能、デザイン、質感、使用シーンで選べる、オフィス空間や働き方を新しくする<br />ワークステーションシステムのラインナップ。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://kokuyo.jp/workstation/",
                }
              ]
            }
          ],
        },{
          // floor4/area11
          title: "デスク",
          lead: "効率的に仕事をこなすワーカーのために、シンプルでありながら機能性を重視した<br />デスクシステムを揃えました。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 677,
                  y: 323,
                  title: "STRATA <span>[ストラタ]</span>",
                  lead1: "足元の収納スペースが充実。広々とした机上を確保できるコンパクトなデスク。",
                  lead2: "・足元スペースを収納として活用し、整理された机上をサポート。<br />・デスクのレイアウトに合わせて配線ダクトの向きが変更可能。<br />・足元収納が2段のタイプと机上棚を装備した2タイプをご用意。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/strata/",
                },{
                  // ?slide=0&modal=1
                  x: 252,
                  y: 171,
                  title: "iSデスク",
                  lead1: "多様化するITツールに対して、最適な環境を提供する機能と<br />働き方に合わせてタイプを選べるスタンダードデスクです。",
                  lead2: "・大開口で、楽に配線しやすいコードダクト。<br />・働き方や使い方にこだわった奥行き全4タイプをご用意。<br />・充実の収納量とラッチ機構で飛び出しを防止します。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/is/",
                },{
                  // ?slide=0&modal=2
                  x: 618,
                  y: 119,
                  title: "EDIA <span>[エディア]</span>",
                  lead1: "こだわりの機能とバリエーションが、<br />毎日の収納シーンを快適にサポートします。",
                  lead2: "・開けやすい引き手やフラット設計など安心安全を追求した使いやすさを実現。<br />・鍵の閉め忘れを防ぐ、安心のセキュリティ。（オートダイヤルロック<ゼロック>仕様）<br />・地震を感知して収納物の落下を防ぐ落下防止ユニットもご用意してます。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/edia/",
                },{
                  // ?slide=0&modal=2
                  x: 445,
                  y: 177,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212888566001",
                },{
                  // ?slide=0&modal=2
                  x: 727,
                  y: 312,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212883446001",
                }
              ]
            }
          ],
        },{
          // floor4/area12
          title: "Working From Home",
          lead: "テレワークや在宅勤務におすすめのイスやデスク、ツールを揃えました。自分の働き方に合わせて選んでいただけます。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://workstyle.kokuyo.co.jp",
                }
              ]
            }
          ],
        },{
          // floor4/area13
          title: "防災",
          lead: "それぞれのオフィスに最適な防災用品を、いちから研究し、工夫や改良を重ねながら<br />ひとつひとつカタチにしています。",
          slides: [
            {
              text: '',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "https://kokuyo.jp/bousai/",
                }
              ]
            }
          ],
        },
        // ここからACTIVITY
        {
          // floor4/area14（activity1）
          title: "チームシンキング",
          lead: "互いの考えを視覚化して共有し、目線を合わせて、アイデアをだし議論する。",
          slides: [
            {
              text: '時間を決めてチームでアイデアブレストをする。',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 366,
                  y: 385,
                  title: "CHESS <span>[チェス]</span>",
                  lead1: "座面の回転とキャスター移動の組み合わせが、<br />自由な動きを促すスツール。",
                  lead2: "・360度回転する座面が、打ち合わせ時の姿勢をサポート。<br />・足元をすっきりと演出する低床キャスター。<br />・ラウンジ空間に馴染む、クラフト感あるフォルムとカラー。",
                  url: "https://kokuyo.jp/chess/",
                },{
                  // ?slide=0&modal=1
                  x: 612,
                  y: 458,
                  title: "CORne <span>[コルネ]</span>",
                  lead1: "革新的な技術で、新しい座り心地とデザインを<br />実現した木製スツール。",
                  lead2: "・スツールの概念を覆す、驚きの薄さと軽さ。<br />・木のやさしい印象を活かしたグラフィックデザイン。",
                  url: "https://kokuyo.jp/corne/",
                },{
                  // ?slide=0&modal=2
                  x: 814,
                  y: 208,
                  title: "MATERIBO <span>[マテリボ]</span>",
                  lead1: "機能性を備えたホワイトボードが、<br />やさしいカラーをまとってリビングライクに。",
                  lead2: "・ラウンジ空間に馴染むデザインとやさしいカラー。<br />・ワンアクションで折りたため、気軽に持ち運びが可能。<br />・気軽に情報をシェアできるピンナップボードやパンフレットスタンド。",
                  url: "https://kokuyo.jp/materibo/",
                },{
                  // ?slide=0&modal=3
                  x: 533,
                  y: 381,
                  title: "エナジーカート（エナジーシリーズ）",
                  lead1: "働く場所をもっと自由にする。デジタルワークをサポートする電源供給アイテム。",
                  lead2: "・ポータブル電源を搭載したディスプレイとキャリーカートをご用意。<br />・4口のコンセントがあり、複数人の作業にも対応。<br />・軽快なデザインがラウンジ空間やカフェ空間にもぴったり。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/enregyseries/",
                },{
                  // ?slide=0&modal=4
                  x: 393,
                  y: 257 ,
                  title: "INITIA <span>[イニシア]</span>",
                  lead1: "学びをもっとアクティブに。<br />グループワークに最適なフラップテーブル。",
                  lead2: "簡単に操作できる3段階の高さ調節機能。<br />コンパクトに収納できるフラップ機能。<br />アクティブな印象を与える 天板エッジカラー。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/initia/",
                },{
                  // ?slide=0&modal=5
                  x: 248,
                  y: 325,
                  title: "STACKA <span>[スタッカ]</span>",
                  lead1: "空間レイアウトを豊かにする、<br />マルチスタッキングチェアー。",
                  lead2: "空間活用の可能性を広げる、 2通りのスタッキング機能。<br />高効率でありながら、 洗練されたデザイン。<br />ニーズに応える幅広いバリエーション。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/stacka/",
                }
              ]
            },{
              text: 'アイデアを分類・整理しながら共通の考えをまとめる。',
              modals: [
                {
                  // ?slide=1&modal=0
                  x: 557,
                  y: 252,
                  title: "inframe <span>[インフレーム]</span>",
                  lead1: "ゆるく囲い、居心地の良さを感じる、<br />リビングテイストのスクリーンブース。",
                  lead2: "・居心地の良さや抜け感のあるデザインと素材。<br />・置くだけで簡単に導入できるワンユニット設計。",
                  url: "https://kokuyo.jp/inframe/",
                },{
                  // ?slide=0&modal=1
                  x: 607,
                  y: 252,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885310001",
                }
              ]
            },{
              text: '集まって各自が発表をし、意見交換・質疑応答をする。',
              modals: [
                {
                  // ?slide=2&modal=0
                  x: 420,
                  y: 328,
                  title: "All in One <span>[オールインワン]</span>",
                  lead1: "テーブルレスミーティングが可能に。<br />アクティブな交流を機能で支える「ALL IN ONE」チェア。",
                  lead2: "・自由な姿勢がカジュアルなミーティングを可能にします。<br />・持ち回り品も快適にセットできる、オールインワン機能。<br />・オフィスラウンジにも馴染む、豊富な素材のチョイス。",
                  url: "https://kokuyo.jp/allinone/",
                },{
                  // ?slide=2&modal=1
                  x: 619,
                  y: 264,
                  title: "Collesso <span>[コレッソ]</span>",
                  lead1: "「余白」と「緩衝」がキーワード。オフィスラウンジに欠かせない、シャープさと風合いを兼ね備えたソファー。",
                  lead2: "・一つのソファーで、交流と集中を実現する「余白」と「緩衝」。<br />・くつろいでも姿勢は崩さない、ワーク仕様に計算された角度。<br />・多様な交流と集中シーンをかなえる、自由な設計と豊富なバリエーション。",
                  url: "https://kokuyo.jp/collesso/",
                }
              ]
            }
          ]
        },{
          // floor4/area15（activity2）
          title: "チームビルディング",
          lead: "メンバーとの理解・信頼感を深め、チームの一体感や帰属意識を高める。",
          slides: [
            {
              text: '仕事に関わりないことを含めて雑談し、仲間を知る。',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 40, y: 40, title: "", lead1: "", lead2: "",
                  url: "http://kokuyo-furniture.co.jp/products/office/ingreen/",
                }
              ]
            // },{
            //   text: '仕事に関わりないことを含めて雑談し、仲間を知る。',
            //   modals: []
            },{
              text: '親睦を深めるために、食事をともにする。',
              modals: [
                {
                  // ?slide=1&modal=0
                  x: 465,
                  y: 341,
                  title: "Franka <span>[フランカ]</span> ",
                  lead1: "カジュアルからシックな空間まで、シーンに合わせて選べる豊富なバリエーションのカフェテーブルシリーズ。",
                  lead2: "・角形・正方形・円柱の3種類の天板形状をご用意。<br />・単柱と、木脚とスチール脚から選べる4本脚の2種類の脚タイプ。<br />・小物が置けるトレーやカバンフックなどのオプションも充実。",
                  url: "https://kokuyo.jp/franka/",
                },{
                  // ?slide=1&modal=1
                  x: 585,
                  y: 381,
                  title: "Patio <span>[パティオ]</span>",
                  lead1: "オフィスの中に自然を感じる空間を。<br />ワークをサポートする機能性も備えたカフェラウンジシリーズ。",
                  lead2: "・グリーンが空間をシンボリックに彩り、居心地のよい雰囲気を演出。",
                  url: "http://kokuyo-furniture.co.jp/products/office/patio/",
                },{
                  // ?slide=1&modal=2
                  x: 169,
                  y: 275,
                  title: "Welca <span>[ウェルカ]</span>",
                  lead1: "ワークツールやカフェアイテムを自由にセット。<br />遊び心のあるデザインのツールワゴン。",
                  lead2: "・用途に合わせて、必要なツールをセッティング可能。<br />・セッティングの自由度を高める機能性。",
                  url: "https://kokuyo.jp/welca/",
                },{
                  // ?slide=1&modal=3
                  x: 505,
                  y: 341,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212880942001",
                },{
                  // ?slide=1&modal=4
                  x: 620,
                  y: 405,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212884844001",
                },{
                  // ?slide=1&modal=5
                  x: 209,
                  y: 275,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212883942001",
                }
              ]
            },{
              text: 'グループミーティングなど、少人数で状況・進捗を共有する。',
              modals: [
                {
                  // ?slide=2&modal=0
                  x: 545,
                  y: 294,
                  title: "Region <span>[リージョン]</span>",
                  lead1: "高さと視線のズレが、居心地のよさと<br />適度な距離感を生むラウンジ空間向けテーブル。",
                  lead2: "・「ソロワークとコミュニケーション」を両立・選択できる絶妙な距離設定。<br />・多様な空間作りをかなえる、組み合わせも可能なバリエーション。<br />・ラフさと上質さ。ラウンジに不可欠な、相反する要素を体現するデザイン。",
                  url: "https://kokuyo.jp/region/",
                },{
                  // ?slide=2&modal=1
                  x: 140,
                  y: 252,
                  title: "collesso <span>[コレッソ]</span>",
                  lead1: "「余白」と「緩衝」がキーワード。オフィスラウンジに欠かせない、シャープさと風合いを兼ね備えたソファー。",
                  lead2: "・一つのソファーで、交流と集中を実現する「余白」と「緩衝」。<br />・くつろいでも姿勢は崩さない、ワーク仕様に計算された角度。<br />・多様な交流と集中シーンをかなえる、自由な設計と豊富なバリエーション。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/collesso/",
                }
              ]
            }
          ]
        },{
          // floor4/area16（activity3）
          title: "髙集中ワーク",
          lead: "外部からの刺激を遮断、あるいは限定して、ひとつのことに没頭する・深める。",
          slides: [
            {
              text: '仮眠や瞑想などで気持ちを落ち着かせ、リセットする。',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 597,
                  y: 260,
                  title: "dop <span>[ドップ]</span>",
                  lead1: "好みに合わせて動く、究極のソロブース",
                  lead2: "・好みの姿勢で仕事ができます。<br />・ワークをサポートする充実した機能。<br />・選べるパネルバリエーション。",
                  url: "https://kokuyo.jp/dop/",
                },{
                  // ?slide=0&modal=1
                  x: 136,
                  y: 244,
                  title: "inframe <span>[インフレーム]</span>",
                  lead1: "ゆるく囲い、居心地の良さを感じる、<br />リビングテイストのスクリーンブース。",
                  lead2: "・居心地の良さや抜け感のあるデザインと素材。<br />・置くだけで簡単に導入できるワンユニット設計。",
                  url: "https://kokuyo.jp/inframe/",
                }
              ]
            },{
              text: 'リラックスしがら資料を読み、思考を行う。',
              modals: [
                {
                  // ?slide=1&modal=0
                  x: 416,
                  y: 224,
                  title: "Notion <span>[ノーション]</span>",
                  lead1: "心身はリラックスしながらも、思考を止めない。美しい所作でのリラックス＆ワークをかなえるブラウジングチェアー。",
                  lead2: "・安らぎを感じる、体を包み込むフォルム。<br />・肩甲骨から頭を起こすシェードと肘形状が、最適なブラウジング姿勢を生み出します。<br />・ラウンジ空間になじむ、素材やフレームへのこだわり。",
                  url: "https://kokuyo.jp/notion/",
                },{
                  // ?slide=1&modal=1
                  x: 711,
                  y: 279,
                  title: "interval <span>[インターバル]</span>",
                  lead1: "仕事の合間に気分をリフレッシュしつつ、快適にワークもできるスクリーンパネルとテーブル付きのソファーです。",
                  lead2: "・ゆったりと囲われ、リラックスできるデザイン。<br />・周りとつながりを感じられる設計。<br />・ワークもできる機能性を装備。",
                  url: "https://kokuyo.jp/interval/",
                }
              ]
            },{
              text: '刺激や着想を得るために、情報をインプットする・学ぶ。',
              modals: [
                {
                  // ?slide=2&modal=0
                  x: 424,
                  y: 273,
                  title: "SENTIR <span>[センティア]</span>",
                  lead1: "ワークとライフが結びつく今、心地よい場に人は集い、つながっていく。オーダーメイドのような選択肢のワークステーション。",
                  lead2: "・空間デザインの可能性を広げる2000通りの組み合わせ。<br />・機能を素材で包み込んだ細やかなデザイン。",
                  url: "https://kokuyo.jp/sentir/",
                },{
                  // ?slide=2&modal=1
                  x: 183,
                  y: 181,
                  title: "JUKE <span>[ジューク]</span>",
                  lead1: "ユニットの組み合わせでフレキシブルに<br />「仕切る」「囲う」ことができるシンプルなシェルフシリーズ。",
                  lead2: "・細いフレームと棚板のシンプルな構成が様々な空間に調和します。<br />・オープン／クローズと、高さ違いの組み合わせで空間にリズムを生み出します。<br />・働き方に配慮した機能的なユニット。",
                  url: "https://kokuyo.jp/juke/",
                },{
                  // ?slide=0&modal=2
                  x: 704,
                  y: 154,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885322001",
                }
              ]
            },{
              text: 'プレゼンの個人練習など、個人で業務を一気に進める。',
              modals: [
                {
                  // ?slide=3&modal=0
                  x: 375,
                  y: 258,
                  title: "SEQUENCE Tilt <span>[シークエンス チルト]</span>",
                  lead1: "身体に優しい姿勢で、心地よく。すべての姿勢をかなえる、<br />天板昇降＆チルト機能付きデスク。",
                  lead2: "・デスクの高さと角度を調整でき、負担が少ない美しい姿勢へ導きます。<br />・PCハンガーやブックスタンドなどの多様なサポートアイテムをご用意。<br />・使い勝手にあわせて2種類から選べる操作パネル。",
                  url: "https://kokuyo.jp/sequence/",
                },{
                  // ?slide=3&modal=1
                  x: 776,
                  y: 170,
                  title: "SEQUENCE <span>[シークエンス]</span>",
                  lead1: "オフィスワークをもっと自由にここちよくさせる、<br />上質な昇降デスクシリーズ。",
                  lead2: "・上質なデザインと豊富なバリエーションでマネジメントやミーティング用にも。<br />・PCハンガーやブックスタンドなどの多様なサポートアイテムをご用意。<br />・使い勝手にあわせて3種類から選べる操作パネル。",
                  url: "https://kokuyo.jp/sequence/",
                }
              ]
            },{
              text: '集中して短時間で作業する',
              modals: [
                {
                  // ?slide=4&modal=0
                  x: 450,
                  y: 336,
                  title: "COODE <span>[コーデ]</span>",
                  lead1: "リビングテイストのミーティングエリアやラウンジなど、<br />ゆったりとした雰囲気に合うミーティングチェアー＆ソファー。",
                  lead2: "・リビングテイストにふさわしい、風合いのあるクロスと柔らかな雰囲気のデザイン<br />・ミーティングに適したクッションの構造・形状・サイズ。",
                  url: "https://kokuyo.jp/coode/",
                },{
                  // ?slide=4&modal=1
                  x: 514,
                  y: 187,
                  title: "Region Adjustable Counter <span>[リージョンアジャスタブルカウンター]</span>",
                  lead1: "オーダーメイドのように、空間に収まるアジャスタブルカウンター。ワークに必須の配線機能をミニマルに完備。",
                  lead2: "・柱間にきれいにおさまる、伸縮するフレーム構造<br />・アクティブなワーカーに欠かせない、細やかな配線への心配り。<br />・リビングオフィスに最適な、温かな素材感。",
                  url: "https://kokuyo.jp/regioncounter/",
                }
              ]
            },{
              text: 'リモートワーカーと効果的なWebミーティングを行う。',
              modals: [
                {
                  // ?slide=5&modal=0
                  x: 153,
                  y: 211,
                  title: "WORK POD <span>[ワークポッド]</span>",
                  lead1: "優れた換気性能を誇るクローズド環境を実現。WEB会議や一人での集中作業に最適なポッド。",
                  lead2: "・約30秒に一度、空気を入れ換える換気性能を搭載。<br />・ガラス面を大きくすることで空間の開放感を保ちます。<br />・スタンディング仕様とソファ仕様の2タイプをご用意しています。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/workpod/",
                }
              ]
            }
          ]
        },{
          // floor4/area17（activity4）
          title: "オペレーションワーク",
          lead: "周囲の雰囲気や動きを感じながら、個人の仕事をスピーディに進める。",
          slides: [
            {
              text: '資料作成やルーチンワークなどの個人作業を効率よく行う。',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 393,
                  y: 252,
                  title: "UPTIS",
                  lead1: "身体に優しい姿勢で、心も上向きに。<br />快適とはかどりをサポートする角度調整型ワークステーション。",
                  lead2: "・デスク天板の傾斜角度を調整可能。<br />・負荷の少ない姿勢に導きます。<br />・緩やかな領域と整ったデスク周りが、集中環境を生み出します。",
                  url: "https://kokuyo.jp/uptis/",
                },{
                  // ?slide=0&modal=1
                  x: 480,
                  y: 393,
                  title: "ing <span>[イング]</span>",
                  lead1: "前後左右360°、ストレスフリーに座面が揺れる。<br />動きながら、働くためのコンディションが整うイス。",
                  lead2: "・体の自由な動きをさまたげない、360°グライディング機構。<br />・グライディングをより効果的にするさまざまなファンクション。<br />・クッションタイプ、メッシュタイプなど豊富なバリエーションをご用意。",
                  url: "https://kokuyo.jp/ing/",
                },{
                  // ?slide=0&modal=2
                  x: 619,
                  y: 378,
                  title: "FreeWagon <span>[フリーワゴン]</span>",
                  lead1: "フリーアドレスワークに最適な新ワゴン。<br />アクセスのしやすさと軽快で親しみのあるデザイン。",
                  lead2: "・フリーアドレスにも快適な収納を。空間全体もすっきり美しく整えます。<br />・細やかな工夫と配慮が光る、抜群の収納アクセス。<br />・コーディネイトの幅が広がる、軽快かつスリムなデザイン。",
                  url: "https://kokuyo.jp/freewagon/",
                }
              ]
            },{
              text: '周囲を意識しながら、個人作業を推し進める。',
              modals: [
                {
                  // ?slide=1&modal=0
                  x: 359,
                  y: 290,
                  title: "SOLANA <span>[ソラナ]</span>",
                  lead1: "環境変化に容易に対応。心地よい距離と安心感をつくるワークステーション。",
                  lead2: "・用途に合わせて、必要なツールを セッティング可能。<br />・デジタルワークと姿勢をサポートする 機能、オプションが充実。<br />・心地よくワークできる抗ウイルス素材の 天板もご用意。",
                  url: "https://kokuyo.jp/solana/",
                },{
                  // ?slide=1&modal=1
                  x: 569,
                  y: 351,
                  title: "FABRE <span>[ファブレ]</span>",
                  lead1: "リビングライクな空間に溶けこむ、<br />なめらかな曲線を描くオフィスチェアー。",
                  lead2: "・カジュアルなオフィス空間に適したデザイン＆ファブリック。<br />・デスクワークに必要な座り心地と骨盤サポート機能。<br />・ワークモード切り替え時のスムーズな操作性。",
                  url: "https://kokuyo.jp/fabre/",
                },{
                  // ?slide=1&modal=2
                  x: 650,
                  y: 247,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885446001",
                },{
                  // ?slide=1&modal=3
                  x: 420,
                  y: 380,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885231001",
                },{
                  // ?slide=1&modal=3
                  x: 716,
                  y: 227,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212888567001",
                }
              ]
            },{
              text: '周囲を意識しながら、個人作業を推し進める。',
              modals: [
                {
                  // ?slide=2&modal=0
                  x: 700,
                  y: 267,
                  title: "Region <span>[リージョン]</span>",
                  lead1: "高さと視線のズレが、居心地のよさと<br />適度な距離感を生むラウンジ空間向けテーブル。",
                  lead2: "・「ソロワークとコミュニケーション」を両立・選択できる絶妙な距離設定。<br />・多様な空間作りをかなえる、組み合わせも可能なバリエーション。<br />・ラフさと上質さ。ラウンジに不可欠な、相反する要素を体現するデザイン。",
                  url: "https://kokuyo.jp/region/",
                },{
                  // ?slide=2&modal=1
                  x: 601,
                  y: 264,
                  title: "FOCUS PANEL <span>[フォーカスパネル]</span>",
                  lead1: "集中ワークやWeb会議をサポート。<br />簡単に自分だけの空間をつくれるパネルブース。",
                  lead2: "・デスクに広げて置くだけで、どこでも ソロワークブースに。<br />・スペースの調整も簡単。 収納もスマートに。<br />・ラウンジ空間にも馴染むデザイン。",
                  url: "https://kokuyo.jp/focuspanel/",
                },{
                  // ?slide=2&modal=2
                  x: 631,
                  y: 230,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885322001",
                }
              ]
            }
          ]
        },{
          // floor4/area18（activity5）
          title: "社外関係構築",
          lead: "自社の理念を伝え、共感してもらい、仲間を増やして信頼関係を築く。",
          slides: [
            {
              text: 'クライアントなどを迎え入れ、課題をヒアリングし、相談にものる。',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 465,
                  y: 356,
                  title: "SETTLE <span>[セトル]</span>",
                  lead1: "ラウンジ空間に美しく溶け込み、ワークに必要な機能を備えた<br />新ラウンジチェア。",
                  lead2: "・ロッキング機能の採用でライトワークからリラックスまで幅広く対応。<br />・低床キャスターにより、ラウンジをワークスペースに。<br />・ワークラウンジに適した座り心地とデザイン。",
                  url: "https://kokuyo.jp/settle/",
                },{
                  // ?slide=0&modal=1
                  x: 677,
                  y: 323,
                  title: "METTI <span>[メッティ]</span>",
                  lead1: "リラックスからワークまで、多様な過ごし方ができる<br />リクライニングソファ。",
                  lead2: "・リクライニングの角度調整で、リラックスとワークのモードの切り替えが可能。<br />・クッション、オットマンなど自由な姿勢を叶えるサポートアイテム。<br />・「ちょい掛け」できる段差が気軽に集まる場を演出。",
                  url: "https://kokuyo.jp/metti/",
                }
              ]
            }
          ]
        },{
          // floor4/area19（activity6）
          title: "特殊専門ワーク",
          lead: "特殊機能や環境が必要な、業界・業種特有の専門的な仕事を行う。",
          slides: [
            {
              text: '一定期間継続して集まり、集中してプロジェクト作業を行う。',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 533,
                  y: 280,
                  title: "SOLANA <span>[ソラナ]</span>",
                  lead1: "環境変化に容易に対応。心地よい距離と安心感をつくるワークステーション。",
                  lead2: "・用途に合わせて、必要なツールを セッティング可能。<br />・デジタルワークと姿勢をサポートする 機能、オプションが充実。<br />・心地よくワークできる抗ウイルス素材の 天板もご用意。",
                  url: "https://kokuyo.jp/solana/",
                },{
                  // ?slide=0&modal=1
                  x: 239,
                  y: 196,
                  title: "JUKE <span>[ジューク]</span>",
                  lead1: "ユニットの組み合わせでフレキシブルに<br />「仕切る」「囲う」ことができるシンプルなシェルフシリーズ。",
                  lead2: "・細いフレームと棚板のシンプルな構成が様々な空間に調和します。<br />・オープン／クローズと、高さ違いの組み合わせで空間にリズムを生み出します。<br />・働き方に配慮した機能的なユニット。",
                  url: "https://kokuyo.jp/juke/",
                },{
                  // ?slide=0&modal=2
                  x: 570,
                  y: 300,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885446001",
                },{
                  // ?slide=0&modal=2
                  x: 140,
                  y: 116,
                  title: "動画",
                  lead1: "",
                  lead2: "",
                  url: "https://players.brightcove.net/4907834175001/default_default/index.html?videoId=6212885311001",
                }
              ]
            }
          ]
        },{
          // floor4/area20（activity7）
          title: "高機密性ワーク",
          lead: "高いセキュリティを要する情報を扱った議論などを行う。",
          slides: [
            {
              text: '人事やプライバシーに関わる面談など、信頼できる環境のもとで安心して行う。',
              modals: [
                {
                  // ?slide=0&modal=0
                  x: 442,
                  y: 310,
                  title: "AIRTRIEVE <span>[エアトリーブ]</span>",
                  lead1: "安心して向き合える会議空間を。<br />飛沫吸引・空気清浄機能を備えた会議用テーブル。",
                  lead2: "部屋全体の浮遊ウイルスも除去。<br />目詰まりしにくい電子式集塵フィルター搭載。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/airtrieve/",
                },{
                  // ?slide=0&modal=1
                  x: 584,
                  y: 381,
                  title: "Duora <span>[デュオラ]</span>",
                  lead1: "独自開発の背もたれ調節機能が<br />作業姿勢の変化や体格差に応じた最適サポートを実現。",
                  lead2: "背骨のS字形状を保つための3つのサポート機能を搭載。<br />最適なボジションに調整できる可動肘。<br />白い脚部が汚れにくいクリーンテクトコーティング。",
                  url: "https://www.kokuyo-furniture.co.jp/products/office/duora/",
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
export default allData;
